import { useCallback, useState } from 'react';
import { useChainId } from 'src/hooks/chain';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { components } from 'src/infrastructure/rest-api/generated';
import { buildApiUrl, useApiMutation } from 'src/infrastructure/rest-api/useApi';

type CreateChainFurnitureZoneInput = components['schemas']['CreateChainFurnitureZoneInput'];

export const useChainFurnitureZoneSaveChanges = () => {
    const chainId = useChainId();
    const showSnackbar = useChangesSnackbar();
    const [isUpdating, setIsUpdating] = useState(false);

    const [createFurnitureZone] = useApiMutation('/api/inventorymanagement/chains/{chainId}/furniturezones', 'post', {
        update: (_data, variables, queryClient) => {
            queryClient.invalidateQueries({
                queryKey: [buildApiUrl('/api/inventorymanagement/chains/{chainId}/furniturezones', variables.path)],
            });
        },
    });

    const saveChanges = useCallback(
        async (input: CreateChainFurnitureZoneInput) => {
            setIsUpdating(true);

            try {
                const response = await createFurnitureZone({ path: { chainId }, body: input });
                showSnackbar();
                return response;
            } catch (err) {
                showSnackbar(err);
            } finally {
                setIsUpdating(false);
            }
        },
        [chainId, createFurnitureZone, showSnackbar]
    );

    return [saveChanges, { loading: isUpdating }] as const;
};
